import React, { useState } from "react";
import Modal from "../Modal";
import SettingFamilyCard from "../SettingFamilyCard/SettingFamilyCard";
import SettingPermitModal from "../SettingPermitModal/SettingPermitModal";
import { Observer } from "mobx-react";
import { toJS } from "mobx";
import AuthStore from "../../store/AuthStore";
import SettingsStore from "../../store/SettingsStore";

const SettingFamilyAccess = () => {
  const [openModal, setOpenModal] = useState(false);
  const [toggleConfig, setToggleConfig] = useState();
  const [isToggleDisable] = useState({
    user21Istoggle: true,
    user22Istoggle: true,
    user23Istoggle: true,
    user24Istoggle: true,
  });
  const [isAllDis] = useState(null);
  const [userType, setUserType] = useState("");
  const [userData, setUserData] = useState([]);

  const handleToggle = (e, data) => {
    const { name } = e.target;

    if (name !== "All") {
      setUserData([data]);
      setToggleConfig(!data.accessEnabled);
      setUserType(name);
      setOpenModal(true);
    } else if (
      data.map((familyMember) => familyMember.accessEnabled).every(Boolean)
    ) {
      setUserType("All");
      setUserData(data);
      setToggleConfig(isAllDis);
      setOpenModal(true);
    } else if (
      // data.length > 1 &&
      !data.map((familyMember) => familyMember.accessEnabled).every(Boolean)
    ) {
      const payload = data.map((familyMember) => {
        return {
          accessEnabled: true,
          client: {
            user_id: familyMember.client.user_id,
          },
        };
      });
      window.scrollTo(0, 0);
      AuthStore.updateLoadingFullScreen(true);
      SettingsStore.callUpdateFamilyAccessData(payload);
    }
  };

  const toggle = (data) => {
    if (data.length === 1) {
      const payload = [];
      payload.push({
        accessEnabled: !data[0].accessEnabled,
        client: {
          user_id: data[0].client.user_id,
        },
      });
      window.scrollTo(0, 0);
      AuthStore.updateLoadingFullScreen(true);
      SettingsStore.callUpdateFamilyAccessData(payload);
    } else if (
      data.length > 1 &&
      data.map((familyMember) => familyMember.accessEnabled).every(Boolean)
    ) {
      const payload = data.map((familyMember) => {
        return {
          accessEnabled: false,
          client: {
            user_id: familyMember.client.user_id,
          },
        };
      });
      window.scrollTo(0, 0);
      AuthStore.updateLoadingFullScreen(true);
      SettingsStore.callUpdateFamilyAccessData(payload);
    }
    setOpenModal(false);
  };

  const getAllMembersImageData = () => {
    return userData.map((eachClientObj) => {
      return {
        title: eachClientObj.client.full_name,
        image:
          SettingsStore.familyMemberAccessImages?.[
            eachClientObj.client.user_id
          ],
      };
    });
  };

  return (
    <Observer>
      {() => (
        <>
          <div className="setting_noti_container">
            <SettingFamilyCard
              isAllDis={
                SettingsStore.familyMemberAccessData
                  ? SettingsStore.familyMemberAccessData
                      .map((familyMember) => familyMember.accessEnabled)
                      .every(Boolean)
                  : false
              }
              isToggleDisable={isToggleDisable}
              family_data={toJS(SettingsStore.familyMemberAccessData)}
              getFamilyMemberImageFrom={SettingsStore.familyMemberAccessImages}
              width={"762px"}
              handleToggle={(e, data) => handleToggle(e, data)}
            />
          </div>

          <Modal
            onClose={() => setOpenModal(false)}
            open={openModal}
            width="438px"
            minWidth="438px"
            modalContainerClass="disable_device_modal_container"
          >
            <SettingPermitModal
              userType1={userType}
              data={userData}
              getFamilyMemberImageFrom={SettingsStore.familyMemberAccessImages}
              isToggleDisable={toggleConfig}
              type={"access"}
              allMembersImagedata={getAllMembersImageData()}
              onClose={() => setOpenModal(false)}
              userType={"your Family Member Access"}
              image={""}
              toggle={(data) => toggle(data)}
            />
          </Modal>
        </>
      )}
    </Observer>
  );
};

export default SettingFamilyAccess;
